module.exports = __webpack_public_path__ + "img/circle.adb067e9.png";